<template>
<div role="group" class="b-form-group form-group">
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('GOALS')">
        <inputvalidation :formerror="formError" name="goals">
          <b-form-textarea v-model="formData.goals" type="text" :rows="3" :max-rows="6"></b-form-textarea>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('PERIOD')">
        <inputvalidation :formerror="formError" name="period">
          <b-form-input type="text" v-model="formData.period"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('EVALUATION')">
        <inputvalidation :formerror="formError" name="evaluation">
          <b-form-textarea v-model="formData.evaluation" type="text" :rows="3" :max-rows="6"></b-form-textarea>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
</div>
</template>

<script>
export default
{
    name: 'WorkTypeForm',
    props: ['formData', 'formError'],
};
</script>
